<template>
	<draggable v-model="elements" @change="log" v-bind="$attrs" tag="transition-group" class="flex" animation="150">
		<slot v-bind:item="element" v-for="(element, index) in elements" :key="index" />
	</draggable>
</template>

<script>
	import { VueDraggableNext as draggable } from 'vue-draggable-next';

	export default {
		name: 'AppDraggable',
		components: { draggable },
		props: ['modelValue'],
		emits: ['moved'],
		computed: {
			elements: {
				get() {
					return [...this.modelValue];
				},
			},
		},
		methods: {
			log({ moved }) {
				this.$emit('moved', moved);
			},
		},
	};
</script>
